import { useSelectedItemStore } from '~/work/skillDiscovery/hooks/useSelectedItemStore';
import { getIdentifier } from '~/work/skillDiscovery/utils';
import { SkillDiscoveryItem as Item } from '@gmm/sdk-voodoo/skillDiscovery';

/**
 * Subscribes to whether the item's `selected` status changes.
 * Used to force re-render of a component (TreeItemChildren) when its selection status changes,
 * but also to NOT re-render when a new selection has nothing to do with this item.
 */
export const useTriggerOnItemSelectionChange = (item: Item | null): void => {
  useSelectedItemStore(state => {
    const selected = state.getSelectedItem();
    const selectedId = selected ? getIdentifier(selected) : null;
    const itemId = item ? getIdentifier(item) : null;

    return selectedId === itemId;
  });
};
